/********************************
 * 
 * @file Defines custom javascript used in the theme.
 * @version 1.0
 * @author Jordan Pinski
 * 
 *******************************/

jQuery( document ).ready(function($) {

  /**************************
   * Plugin Loader
   *************************/
  class PluginLoader {
    constructor() {
      this.jQueryAccordion = $('.accordion').length > 0 ? $('.accordion') : false;
      this.jQueryResponsiveTabs = $('.responsive-tabs').length > 0 ? $('.responsive-tabs') : false;
      this.jQueryBackgroundVideo = $('.background-video').length > 0 ? $('.background-video') : false;
      this.slick = $('.slick').length > 0 ? $('.slick') : false;
      this.readmore = $('.read-more').length > 0 ? $('.read-more') : false;
      this.init();
    }

    /**
     * Initializes plugins
     */
    init() {

      // jQuery Accordion
      // https://github.com/vctrfrnndz/jquery-accordion
      if (this.jQueryAccordion) {

        // Initialize each accordion with its parent's (data-accordion-group) data.
        this.jQueryAccordion.each( (index, value) => {
          let $elAccordion = $(value);
          let $elParent = $elAccordion.parent('[data-accordion-group]');

          $elParent.data = {
            transitionSpeed: $elParent.data('transition-speed') || 350,
            transitionEasing: $elParent.data('transition-easing') || 'ease',
            singleOpen: $elParent.data('single-open') || true
          }
  
          $elAccordion.accordion({
            'transitionSpeed': $elParent.data.transitionSpeed,
            'transitionEasing': $elParent.data.transitionEasing,
            'singleOpen': $elParent.data.singleOpen
          });
        })

      }

      // jQuery Responsive Tabs
      // https://github.com/jellekralt/Responsive-Tabs
      if (this.jQueryResponsiveTabs) {
        this.jQueryResponsiveTabs.responsiveTabs({
          startCollapsed: 'accordion'
        });
      }

      // jQuery Background Video
      // https://github.com/BGStock/jquery-background-video
      if (this.jQueryBackgroundVideo) {
        this.jQueryBackgroundVideo.data = {
          showOnMobile: this.jQueryBackgroundVideo.data('show-mobile') || false
        }

        this.jQueryBackgroundVideo.bgVideo({
          pauseAfter: 0,
          showPausePlay: false
        })

        // Hide background video on screen sizes less than 768px
        const windowWidth = window.innerWidth;

        if (windowWidth < 768 && this.jQueryBackgroundVideo.data.showOnMobile == false) {
          this.jQueryBackgroundVideo.css('display', 'none');
        }
      }

      // slick
      // https://github.com/kenwheeler/slick
      if (this.slick) {

        // Initialize each slick slide with it's own data.
        this.slick.each( (index, value) => {
          let $elSlick = $(value);

          $elSlick.data = {
            slides: $elSlick.data('slides') || 4,
            slides_sm: $elSlick.data('slides-sm') || 1,
            slides_md: $elSlick.data('slides-md') || 2,
            slides_lg: $elSlick.data('slides-lg') || 3,
            slides_xl: $elSlick.data('slides-xl') || 4
          }
          
          $elSlick.slick({
            slidesToShow: $elSlick.data.slides,
            responsive: [
              {
                // Extra Large
                breakpoint: 1200,
                settings: {
                  slidesToShow: $elSlick.data.slides_xl
                }
              },
  
              {
                // Large
                breakpoint: 992,
                settings: {
                  slidesToShow: $elSlick.data.slides_lg
                }
              },
  
              {
                // Medium
                breakpoint: 768,
                settings: {
                  slidesToShow: $elSlick.data.slides_md
                }
              },
  
              {
                // Small
                breakpoint: 576,
                settings: {
                  slidesToShow: $elSlick.data.slides_sm
                }
              }
            ]
          });
        });
      }

      // readmore
      // https://github.com/jedfoster/Readmore.js
      if (this.readmore) {

        // Loop through each instance of .read-more
        this.readmore.each( (index, value) => {

          let $elReadMore = $(value);

          $elReadMore.data = {
            buttonMore: $elReadMore.data('button-more') || '<a href="#" class="button button--primary" title="Read More">Read More</a>',
            buttonLess: $elReadMore.data('button-less') || '<a href="#" class="button button--primary" title="Read Less">Read Less</a>',
            speed: $elReadMore.data('speed') || 100
          }

          // Until speed issue is resolved, manually add transition and overflow rules
          $elReadMore.css({
            'transition': 'height ' + $elReadMore.data.speed + 'ms ease',
            'overflow': 'hidden'
          })

          $elReadMore.readmore({
            //speed: $elReadMore.data.speed, // Speed not working? TODO: Figure out why.
            moreLink: $elReadMore.data.buttonMore,
            lessLink: $elReadMore.data.buttonLess,
            collapsedHeight: 0,
            afterToggle: (trigger, element, expanded) => {
              let $element = $(element);
              let $elAccordions = $element.find('.accordion');
              const initialHeight = $element.height();

              console.log(initialHeight);

              $elAccordions.on('click', function() {
                const $this = $(this);
                const $content = $this.find('[data-content]');
                let transitionSpeed = 0;

                // Set an inital timeout after the accordion is clicked to grab the transition duration.
                setTimeout(function() {
                  transitionSpeed = getTransitionDuration($content);

                  // Set another timeout using the transition duration & add to the readmore divs max-height.
                  setTimeout(function() {
                    let accordionHeight = $this.outerHeight();
                    let newHeight = 0;

                    if ($this.hasClass('open')) {
                      newHeight = initialHeight + accordionHeight;
                    } else {
                      newHeight = initialHeight;
                    }

                    $element.css('height', newHeight + 'px');
                  }, transitionSpeed * 1000);
                }, 1);



              });
            }
          });

        });

      }
    };
  }

  const pluginLoader = new PluginLoader();

  /**************************
   * Back To Top
   *************************/
  class BackToTop {
    constructor() {
      this.$elBackToTop = $('.back-to-top').length > 0 ? $('.back-to-top') : false;
      this.bindEvents();
    }

    bindEvents() {
      if (this.$elBackToTop) {
        $(window).scroll( () => {
          this.handleScroll();
        });
  
        this.$elBackToTop.click( (event) => {
          event.preventDefault();
          this.animateToTop();
        });
      }
    }

    animateToTop() {
      $("html, body").animate({ scrollTop: 0 }, 600);
    }

    handleScroll() {
      // Errors with $(window).offset().top;
      const offsetTop = window.scrollY;

      if (offsetTop > 600) {
        this.$elBackToTop.addClass('is-active');
      } else {
        this.$elBackToTop.removeClass('is-active');
      }
    }
  }

  const backToTop = new BackToTop();

  /**************************
   * Banner
   *************************/
  class Banner {
    constructor() {
      this.$elBannerTop = $('.sticky-banner.sticky-banner--top') || false;
      this.$elBannerBottom = $('.sticky-banner.sticky-banner--bottom') || false;
      this.$elTopCloseBtn = this.$elBannerTop.find('.sticky-banner__close-button') || false;
      this.$elBottomCloseBtn = this.$elBannerBottom.find('.sticky-banner__close-button') || false;
  
      this.state = {
        topSticky: this.$elBannerTop.data('sticky') || false,
        bottomSticky: this.$elBannerBottom.data('sticky') || false,
        isTopOpen: this.$elBannerTop.css('display') == 'none' ? false : true,
        isBottomOpen: this.$elBannerTop.css('display') == 'none' ? false : true,
      };
  
      this.init();
      this.bindEvents();
    }

    /**
     * Initializes the banner
     */
    init() {

      // Banner Top
      if (this.$elBannerTop) {
        if (this.state.topSticky) {
          this.$elBannerTop.addClass('fixed');
        }
      }

      // Banner Bottom
      if (this.$elBannerBottom) {
        if (this.state.bottomSticky) {
          this.$elBannerBottom.addClass('fixed');

          // Add a bottom margin to the footer
          $('footer').css('marginBottom', this.$elBannerBottom.outerHeight() + 'px');

        }
      }
    }

    /**
     * Bind banner events
     */
    bindEvents() {

      if (this.$elTopCloseBtn) {
        this.$elTopCloseBtn.on('click touch', () => {
          this.$elBannerTop.hide();
          $('header.header-main').css('marginTop', '0');
          this.state.isTopOpen = false;
        });
      }
  
      if (this.$elBottomCloseBtn) {
        this.$elBottomCloseBtn.on('click touch', () => {
          this.$elBannerBottom.hide();
          $('footer').css('marginBottom', '0');
          this.state.isBottomOpen = false;
        });
      }
    }
  }


  /**************************
   * Class: Header
   * Version: 1.0.1
   * Last Modified: 3.25.19
   *************************/
  class Header {
    constructor() {
      this.$elHeader = $('header.header');
      this.$elBanner = $('.banner');
      this.$elInnerBanner = $('.inner-banner');
  
      this.state = {
        offsetTop: this.$elHeader.offset().top,
        height: this.$elHeader.outerHeight(),
        threshold: null,
        isSticky: this.$elHeader.data('sticky') == true ? true : false
      };
  
      this.init();
      this.bindEvents();
    }

    init() {
      this.state.threshold = this.state.offsetTop + this.state.height;
      this.addMarginBelow();
    }
    
    /**
     * Adds a top margin equal to the height of the header based on what header is being used.
     * Note. All headers need to be positioned absolute to prevent studder when scrolling down (stick)
     * Not all header layouts call for content layered behind the header.
     */
    addMarginBelow() {
      if (this.$elHeader.hasClass('header--10')) {
        this.$elBanner.css('marginTop', this.state.height + 'px');
        this.$elInnerBanner.css('marginTop', this.state.height + 'px');
      }
    }

    bindEvents() {

      if (this.state.isSticky) {
        
        $(window).scroll( () => {
          this.handleStickyHeader();
        });

      }

    }

    /**
     * Apply a .is-sticky class to the header when the user scrolls past it.
     */
    handleStickyHeader() {
      const scrollTop = $(window).scrollTop();

      if (scrollTop > this.state.threshold) {
        this.$elHeader.addClass('is-sticky');
      } else if (scrollTop <= this.state.offsetTop) {
        this.$elHeader.removeClass('is-sticky');
      }

    }

  }

  const header = new Header();

  /**************************
   * Footer
   * @requires Banner
   *************************/
  class Footer {
    constructor() {
      this.$elFooter = $('.footer-main');
      this.banner = new Banner();
  
      this.init();
    }

    /**
     * Initializes the footer
     */
    init() {

      if (this.banner.$elBannerBottom) {
        this.$elFooter.css('paddingBottom', this.banner.$elBannerBottom.outerHeight() + 'px');
      }
    }
  }

  const footer = new Footer();
  
  /**************************
   * Menu
   *************************/
  class Menu {
    constructor() {
      this.$elMenuDesktop = $('.menu.menu--desktop');
      this.$elMenuDesktop_listParentDepth1 = this.$elMenuDesktop.find('li.parent[data-depth="1"]');
      this.$elMenuMobile = $('.menu.menu--mobile');
      this.$elMobileToggle = $('.mobile__toggle');
      this.$elMenuDesktop_dropdownToggle = this.$elMenuDesktop.find('li.parent[data-depth="0"]');
      this.$elMenuMobile_dropdownToggle = this.$elMenuMobile.find('.parent');
  
      this.state = {
        desktop: {
          icon: this.$elMenuDesktop.data('dropdown-icon') || false,
        },
        mobile: {
          icon: this.$elMenuMobile.data('dropdown-icon') || false,
          isOpen: false,
        }
      };

      this.init();
      this.bindEvents();
    }

    /**
     * Initializes the dropdown menus.
     */
    init() {
      this.initCurrentItems();
      this.initDropdownIcons();
    }

    checkDropdownLocation(event, depth) {
      const windowWidth = window.innerWidth;
      const $elTarget = $(event.target);

      let $elDropdown = $elTarget.find('ul.dropdown[data-depth="' + depth + '"]');
      const dropdownPositionLeft = $elDropdown.offset().left + $elDropdown.outerWidth();

      if (dropdownPositionLeft > windowWidth) {
        $elDropdown.addClass('display-left');
      }
    }

    /**
     * Binds all necessary events to both the desktop & mobile menus.
     */
    bindEvents() {

      // List Parent Depth 0
      this.$elMenuDesktop_dropdownToggle.mouseenter( (event) => {
        this.checkDropdownLocation(event, 0);
      });

      // List Parent Depth 1
      this.$elMenuDesktop_listParentDepth1.mouseenter( (event) => {
        this.checkDropdownLocation(event, 1);
      });

      // Mobile Toggle
      this.$elMobileToggle.on('click touch', () => {
        this.$elMenuMobile.toggleClass('active');

        if (this.$elMenuMobile.hasClass('active')) {
          // Get the transition duration. Wait that amount of time before setting the
          // isOpen state.
          const transitionDuration = getTransitionDuration(this.$elMenuMobile);
          
          setTimeout(() => {
            this.state.mobile.isOpen = true;
          }, transitionDuration * 1000);
          
        } else {
          this.state.mobile.isOpen = false;
        }

      });

      // Mobile dropdown toggle
      if (this.$elMenuMobile_dropdownToggle.length > 0) {
        this.$elMenuMobile_dropdownToggle.find('.dropdown-toggle').on('click touch', (event) => {
          const dropdownToggle = $(event.target);
          const dropdownPanel = dropdownToggle.siblings('ul');

          dropdownPanel.toggleClass('active');

          if (dropdownPanel.hasClass('active')) {
            dropdownPanel.css('maxHeight', dropdownPanel[0].scrollHeight + 'px');
          } else {
            dropdownPanel.css('maxHeight', '0px');
          }

        });
      }

      // Mobile Outside Click
      $(document).on('click touch', (event) => {
        const $target = $(event.target);
        const isMobileMenu = $target.closest('.menu--mobile').length > 0;

        if (this.state.mobile.isOpen) {
          if (!isMobileMenu) {
            this.$elMenuMobile.removeClass('active');
            this.state.mobile.isOpen = false;
          }
        }

      });

    }

    /**
     * Adds classes to the current item chain up to depth 1.
     */
    initCurrentItems() {
      this.$elMenuDesktop_dropdownToggle.find('.active').parents('.parent').addClass('active-parent');
      this.$elMenuMobile_dropdownToggle.find('.active').parents('.parent').addClass('active-parent');
    }

    /**
     * Adds a Font Awesome icon to each parent list item anchor.
     */
    initDropdownIcons() {

      if (this.state.desktop.icon) {
        this.$elMenuDesktop_dropdownToggle.each((index, value) => {
          const dropdownToggle = $(value);
          const dropdownIcon = $('<i/>', {"class": 'icon ' + this.state.desktop.icon });
          dropdownToggle.find('a').eq(0).append(dropdownIcon);
        });
      }

      if (this.state.mobile.icon) {
        this.$elMenuMobile_dropdownToggle.each((index, value) => {
          const dropdownToggle = $(value);
          const dropdownIcon = $('<i/>', {"class": 'dropdown-toggle icon ' + this.state.mobile.icon });
          dropdownToggle.append(dropdownIcon);
        });
      }
    }

  }

  const menu = new Menu();

  /**************************
   * Phone Numbers
   *************************/
  class PhoneNumber {
    constructor() {
      this.$elPhoneNumbers = $('[data-phone-number]');

      this.init();

    }

    init() {

      // Loop through each phone number instance and set the data
      this.$elPhoneNumbers.each( (index, value) => {

        let $elPhoneNumber = $(value);

        $elPhoneNumber.data = {
          phoneNumber: $elPhoneNumber.attr('href'),
          destination: $elPhoneNumber.data('destination') || '/about-us/contact-us',
          breakpoint: $elPhoneNumber.data('breakpoint') || 768,
          gtag: $elPhoneNumber.data('gtag') || true
        }

        this.bindEvents($elPhoneNumber);

      });
    }

    bindEvents($elPhoneNumber) {

      // Set the phone number's href
      $(document).ready( () => {
        this.changeHref($elPhoneNumber)
      });

      $(window).resize( () => {
        this.changeHref($elPhoneNumber)
      });

      // Call the gtag event
      if ($elPhoneNumber.data.gtag) {
        $elPhoneNumber.click( () => {
          gtag('event', 'Clicked', {event_category: "Phone Call", event_label: "Phone Number"});
        });
      }

    }

    changeHref($elPhoneNumber) {
      let windowWidth = $(window).innerWidth();

      if (windowWidth > $elPhoneNumber.data.breakpoint) {
        $elPhoneNumber.attr('href', $elPhoneNumber.data.destination);
      } else {
        $elPhoneNumber.attr('href', $elPhoneNumber.data.phoneNumber)
      }
    }

  }
  
  const phoneNumber = new PhoneNumber();

  /**************************
   * Helper Functions
   *************************/
  function getTransitionDuration($element) {
    return $element.css('transitionDuration').replace(/[^0-9.]/g, '');
  }

  function setTransitionDuration($element, duration) {
    $element.css('transition-duration', duration);
  }
  
});